import { render, staticRenderFns } from "./ListarApresentantes.vue?vue&type=template&id=085a3282"
import script from "./ListarApresentantes.vue?vue&type=script&lang=js"
export * from "./ListarApresentantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('085a3282')) {
      api.createRecord('085a3282', component.options)
    } else {
      api.reload('085a3282', component.options)
    }
    module.hot.accept("./ListarApresentantes.vue?vue&type=template&id=085a3282", function () {
      api.rerender('085a3282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ListarApresentantes.vue"
export default component.exports